module.exports = __webpack_public_path__ + "ui-static/img/no-items_dark.c5e5cd30.svg";